import { render, staticRenderFns } from "./Event_over_list.vue?vue&type=template&id=a5f36fd0&"
import script from "./Event_over_list.vue?vue&type=script&lang=js&"
export * from "./Event_over_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports